<nz-card class="header-card" nzSize="small">
  <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  <div class="flex justify-between my-3">
    <h2 class="!text-lg xxsm:!text-2xl my-0">Judgments and Orders</h2>
  </div>
</nz-card>

<nz-card class="!my-4">
  <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 items-start sm:items-center justify-between">
    <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 items-start sm:items-center w-full sm:w-auto">
      <p class="text-[#441752] font-semibold whitespace-nowrap text-sm sm:text-base">Filters:</p>
      <nz-select
        class="w-full sm:w-[200px]"
        nzSize="large"
        [(ngModel)]="selectedYear"
        (ngModelChange)="filterData()"
        nzPlaceHolder="All Years">
        <nz-option *ngFor="let year of years" [nzValue]="year" [nzLabel]="year.toString()"></nz-option>
      </nz-select>
      <nz-select
        class="w-full sm:w-[200px]"
        nzSize="large"
        [(ngModel)]="selectedMonth"
        (ngModelChange)="filterData()"
        nzPlaceHolder="All Months">
        <nz-option *ngFor="let month of months" [nzValue]="month.value" [nzLabel]="month.name"></nz-option>
      </nz-select>
      <button
        *ngIf="selectedYear || selectedMonth"
        class="px-3 sm:px-4 py-2 outline-none border border-solid border-[#441752] text-[#441752] bg-transparent rounded-md whitespace-nowrap text-sm sm:text-base w-full sm:w-auto"
        (click)="clearFilter()">
        Clear Filters
      </button>
    </div>
  </div>
</nz-card>

<nz-empty class="mt-10" *ngIf="data.length === 0"></nz-empty>

<nz-card class="!my-4" *ngIf="data.length > 0">
  <div class="overflow-x-auto" style="scrollbar-width: thin;">
    <nz-table
      [nzData]="data"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      nzSize="middle"
      [nzScroll]="{ x: '1000px' }">
      <thead>
        <tr>
          <th nzWidth="120px">Case No</th>
          <th nzWidth="120px" class="hidden md:table-cell">Date</th>
          <th nzWidth="200px" class="hidden lg:table-cell">Parties</th>
          <th nzWidth="150px" class="hidden lg:table-cell">Judgment By</th>
          <th nzWidth="200px" class="hidden xl:table-cell">Summary</th>
          <th nzWidth="120px" class="text-center">Document</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let judgment of data">
          <td class="font-medium text-[#441752]">{{ judgment.caseNo || 'N/A' }}</td>
          <td class="hidden md:table-cell">{{ formatDate(judgment.dateOfJudgment) }}</td>
          <td class="hidden lg:table-cell">{{ judgment.namesOfParties || 'N/A' }}</td>
          <td class="hidden lg:table-cell">{{ judgment.judgmentBy || 'N/A' }}</td>
          <td class="hidden xl:table-cell">
            <span class="block">{{ judgment.summary || 'N/A' }}</span>
          </td>
          <td>
            <div class="flex flex-col items-center">
              <a
                *ngIf="getFileUrl(judgment.document) !== '#'"
                [href]="getFileUrl(judgment.document)"
                target="_blank"
                nz-button
                nzSize="small"
                nzType="primary">
                Download
              </a>
              <span
                *ngIf="getFileUrl(judgment.document) === '#'"
                class="text-gray-400 text-sm">
                No document
              </span>
              <!-- Mobile view: show additional info -->
              <div class="md:hidden mt-2 text-left space-y-1 text-xs text-gray-600 w-full">
                <div><strong>Date:</strong> {{ formatDate(judgment.dateOfJudgment) }}</div>
                <div><strong>Parties:</strong> {{ judgment.namesOfParties || 'N/A' }}</div>
                <div><strong>By:</strong> {{ judgment.judgmentBy || 'N/A' }}</div>
                <div *ngIf="judgment.summary"><strong>Summary:</strong> <span>{{ judgment.summary }}</span></div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</nz-card>

<div class="mt-4 flex justify-center sm:justify-end" *ngIf="data.length > 0">
  <nz-pagination
    class="mt-4 sm:mt-8"
    (nzPageIndexChange)="onCurrentPageDataChange($event)"
    [nzPageIndex]="currentPage"
    [nzTotal]="totalDocs"
    [nzPageSize]="pageSize"
    [nzSimple]="false"
    [nzShowSizeChanger]="false"
    nzSize="small"></nz-pagination>
</div>




